import { UnauthorizedAccessEvent } from '@shared/event/unauthorized-access.event.js'
import { EVENTS } from '@shared/events';

function HTTPInterceptor($q, $state, EventDispatcherService) {
  'ngInject';

  return {
    response: function(response, status, headers) {
      switch (response.status) {
      case 200:
        if (response.headers()['x-redirect-url']) {
          window.location = response.headers()['x-redirect-url'];
        }

        break;
      }
      
      return response.data;
    },

    responseError: function(response) {
      let deferred = $q.defer();

      switch (response.status) {
      case 401:
        const event = new UnauthorizedAccessEvent();
        EventDispatcherService.dispatch(EVENTS.UNAUTHORIZED_ACCESS, event);
        if ($state.current.name !== 'signin') {
          $state.go('log-out');
        }
        break;
      case 403:
        $state.go('forbidden');
        break;
      case 422:
        // FORM ERRORS
        deferred.reject(response.data);
        break;
      case 400:
        deferred.reject(response.data.message);
        break;
      }

      return deferred.promise;
    }
  };
}

export default HTTPInterceptor;



// WEBPACK FOOTER //
// ./client/app/shared/http/http.interceptor.js